import { t } from "i18next";
import { CATEGORIES_NUM_KEYS } from "../../utils";

export const mapComparisonData = (inputData) => {
  const categories = [];
  for (let i = 0; i < 15; i++) {
    const categoryName = t(`supplierQuestionnaire.scopeThree.categories.category${CATEGORIES_NUM_KEYS[i]}.name`, {
      defaultValue: ""
    });
    categories.push({
      label: `${t("dashboard.emissionsDataChart.types.category")} ${i + 1}`,
      key: `CATEGORY_${i + 1}`,
      categoryName
    });
  }
  const emissionsTypes = [
    { label: `${t("dashboard.emissionsDataChart.types.scope")} 1`, key: "SCOPE_1" },
    { label: `${t("dashboard.emissionsDataChart.types.scope")} 2`, key: "SCOPE_2" },
    { label: `${t("dashboard.emissionsDataChart.types.scope")} 3`, key: "SCOPE_3" },
    ...categories
  ];

  return emissionsTypes.map(type => {
    const yearsData = {};
    inputData.forEach(el => {
      yearsData[el.year] = el.emissions?.[type.key] ?? 0;
    });
    const objToReturn = {
      type: type.label,
      ...yearsData
    };

    if (typeof type.categoryName !== "undefined") {
      objToReturn["categoryName"] = type.categoryName;
    }

    return objToReturn;
  });
};

export const roundByLargestRemainderMethod = (values) => {
  let sum = 0;
  let count = 0;
  let order = [];

  values.forEach((value, index) => {
    sum = sum + parseInt(values[index]);
    order[index] = index;
  });
  let diff = 100 - sum;

  order.sort(function(a, b) {
    let dVala = values[a] - parseInt(values[a]);
    let dValb = values[b] - parseInt(values[b]);
    return dValb - dVala;
  });

  values.sort(function(a, b) {
    let dVala = a - parseInt(a);
    let dValb = b - parseInt(b);
    return dValb - dVala;
  });

  values.forEach((value, index) => {
    count = index;
    if (count < diff) {
      values[index] = parseInt(values[index]) + 1;
    } else {
      values[index] = parseInt(values[index]);
    }
  });

  // We return the values rounded and in the same order in which they were passed
  let roundedValues = [];
  values.forEach((value, index) => {
    roundedValues[order[index]] = values[index];
  });

  return roundedValues;
};